









































































import BillingProduct from '@/datatypes/billing/product';
import BillingProductService from '@/services/billing/BillingProductService';
import BillingProductCreateRequest from '@/datatypes/billing/product-create-request';
import { required } from 'vuelidate/lib/validators';
import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    billingProduct: new BillingProduct({}),
    billingProductService: new BillingProductService(),
    isConfirmingProduct: false,
  }),

  validations: {
    billingProduct: {
      name: { required },
    },
  },

  methods: {
    createProduct() {
      const request = new BillingProductCreateRequest(this.billingProduct);

      this.billingProductService.create(request).then((response) => {
        this.$router.push(`/billing-products/${response.data.id}`);
      }).catch((error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },
  },

  computed: {
    productComplete(): boolean {
      if (!this.billingProduct) return false;

      return this.billingProduct.name?.length > 0;
    },
  },
});
